import React from 'react';
import { CheckIcon } from 'lucide-react';
import { benefits } from '../../data/content';
import { BeforeAfterCarousel } from './BeforeAfterCarousel';
export function ImagineBenefits() {
  return <section className="bg-cream py-20 sm:py-28" data-id="element-117" data-mp="2h0m03mijwkpi">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-118" data-mp="2gzb1e13yq359">
        <div className="mx-auto max-w-3xl text-center" data-id="element-119" data-mp="2c2u9cvtn74mw">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-120" data-mp="2c083d0megx6s">Imagine seeing your home differently</p>
          <h2 className="mt-5 font-serif text-4xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-121" data-mp="2244pixi6ra40">
            Floors, walls, kitchens, bathrooms, and furniture can look <em className="text-gold" data-id="element-122" data-mp="1y2jkfybw804d">completely different</em> without starting from scratch.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-body" data-id="element-123" data-mp="1t59m1t6j0e4e">
            You don't always need a full renovation to make your home feel new. Sometimes, the right material, technique, or simple change can make a much bigger difference than you think.
          </p>
        </div>

        <div className="mt-16 grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-124" data-mp="uh70i0ka0s3z">
          <BeforeAfterCarousel data-id="element-125" data-mp="ziwenp2splwa" />
          <div data-id="element-126" data-mp="zfqkvwj81vu8">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-127" data-mp="li216s0w4uqr">Everything you need in one place</p>
            <h3 className="mt-4 font-serif text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-128" data-mp="qgn1ssk21gfq">
              What you'll be able to do with Reforms Without Renovation
            </h3>
            <ul className="mt-8 space-y-5" data-id="element-129" data-mp="1i82yjffbsjjo">
              {benefits.map(b => <li key={b} className="flex gap-4" data-id="element-130" data-mp="1ia5l1ph9rujn">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-131" data-mp="14fv1rno1kskz" />
                  <span className="text-[17px] leading-relaxed text-ink" data-id="element-132" data-mp="19f7psbqng5p5">{b}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}